import PropertyCollapsedRoomPackageActions, {
  type PropertyCollapsedRoomPackageTrackingData,
} from './PropertyCollapsedRoomPackageActions'
import { CroSppCollapsedPackagesVariant } from './useCroSppCollapsedPackagesExperiment'

interface Props {
  duration: number
  rates: Array<App.EnrichedPropertyRate>
  packageCount: number
  packagesExpanded: boolean
  packagesVariant: CroSppCollapsedPackagesVariant
  trackingData: PropertyCollapsedRoomPackageTrackingData
  onTogglePackages: () => void
}

function PropertyRoomPackageVariantActions(props: Props) {
  const {
    duration,
    rates,
    packageCount,
    packagesExpanded,
    packagesVariant,
    trackingData,
    onTogglePackages,
  } = props

  if (packagesVariant === CroSppCollapsedPackagesVariant.control) {
    return null
  }

  return <PropertyCollapsedRoomPackageActions
    duration={duration}
    rates={rates}
    packageCount={packageCount}
    expanded={packagesExpanded}
    trackingData={trackingData}
    onTogglePackages={onTogglePackages}
  />
}

export default PropertyRoomPackageVariantActions
